export const AZURE_MAPS_KEY = process.env.REACT_APP_AZURE_MAPS_KEY;


export const getMapOptions = (panelKey) => ({
    authOptions: {
        authType: 'subscriptionKey',
        subscriptionKey: panelKey || AZURE_MAPS_KEY
    },
    language: 'es-ES',
    view: 'Auto'
});

export const DEFAULT_MAP_OPTIONS = getMapOptions();

export const AZURE_MAPS_STYLES = {
    marker: {
        default: '#1774fa',
        asset: '#49cb5c',
        border: '#fff'
    },
    polygon: {
        color: '#3388ff',
        weight: 4,
        fillColor: '#3388ff',
        fillOpacity: 0.5
    }
};

export const calculateIconSize = (zoom) => {
    return Math.max(10, Math.round(14 - zoom * 0.2));
};

export const calculateAssetIconSize = (zoom) => {
    return Math.max(22, Math.round(36 - zoom * 0.7));
};
